var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDropdownOptionsWrapper',{attrs:{"icon":"plus-square","options":_vm.dropdownOptions,"disabled":!_vm.canCreateContent},on:{"open":function($event){return _vm.$emit('open')},"close":function($event){return _vm.$emit('close')},"select":_vm.handleSelectOption}})
}
var staticRenderFns = []

export { render, staticRenderFns }